module.exports = __webpack_public_path__ + "school/img/biaoyou.ddce1749.jpg";